module.exports = __webpack_public_path__ + "img/team-ad.521cb8e0.png";